import jsPDF from "jspdf";

import html2canvas from "html2canvas";
import "./Css/PrintEqunry.css";
import React, {
    useEffect,
    forwardRef,
    useImperativeHandle,
    useState,
} from "react";
import {
    formatDateStringdot,
    handleError,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader";
const DropFormPDF = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const data = props.downloadForm;
    const carimage = props.carimage;
    const carData = props.carData;
    //console.log("drop_down_data_pdf", data);
    //console.log("carimage", carimage);

    const handleDownloadPDF = () => {
        if (!data || Object.keys(data).length === 0) {
            return;
        }
        setLoading(true);
        const AgreePart1 = document.getElementById("AgreePart1");
        const AgreePart2 = document.getElementById("AgreePart2");

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
            compress: true,
        });

        const renderPart = (element, isFirstPart) => {
            return html2canvas(element, {
                scale: 2, // Increase scale for higher resolution (this will result in larger file size)
                useCORS: true,
                logging: false,
                allowTaint: true,
                letterRendering: true,
                imageTimeout: 0,
                backgroundColor: "#FFFFFF",
            }).then((canvas) => {
                // Use PNG for higher quality
                const imgData = canvas.toDataURL("image/png", 1); // Set quality to 1 for full resolution
                const imgWidth = 210;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;

                if (!isFirstPart) {
                    pdf.addPage();
                }

                pdf.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight - 20);
            });
        };
        renderPart(AgreePart1, true)
            .then(() => renderPart(AgreePart2, false))

            .then(() => {
                pdf.setProperties({
                    title: "Agreement",
                    subject: "Car Rental Agreement",
                    creator: "Rapid Car Leasing",
                    author: "System",
                });

                pdf.save("Drop-of.pdf");
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error generating PDF:", error);
                setLoading(false);
            });
    };

    // useImperativeHandle(ref, () => ({
    //     handleDownloadPDF,
    // }));
    useImperativeHandle(ref, () => ({
        handleDownloadPDF: () => {
            if (!data || Object.keys(data).length === 0) {
                console.warn("Data not ready yet.");
                return;
            }
            handleDownloadPDF();
        },
    }));

    return (
        <div className="Pickup_pdf_form">
            <button onClick={handleDownloadPDF}>Download</button>
            {loading && <Loader />}

            <div id="pdf-content" className="Print_Enqury_contrr">
                {/*----------------------Slide 1-------------------------- */}
                <div className="AgreePart1" id="AgreePart1">
                    <div className="FormHeading">
                        <h1>
                            {data?.first_name || "NA "} {data?.last_name || "NA "}
                        </h1>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Submitter :-</div>
                        <div className="form-value">
                            {data?.first_name || "NA "} {data?.last_name || "NA "}
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Submission Date :-</div>
                        <div className="form-value">{formatDateStringdot(new Date())}</div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Options :-</div>
                        <div className="form-value">Drop-of</div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Date :-</div>
                        <div className="form-value"> {formatDateStringdot(new Date())}</div>
                    </div>{" "}
                    <div className="rowCLssForm">
                        <div className="form-label">Insurance :-</div>
                        <div className="form-value"> {data?.insurance || " NA"}</div>
                    </div>{" "}

                    <div className="rowCLssForm">
                        <div className="form-label">Time :-</div>
                        <div className="form-value"> {data?.from_time || "NA"}</div>
                    </div>{" "}
                    <div className="rowCLssForm">
                        <div className="form-label">Car :-</div>
                        <div className="form-value">
                            ({carData?.car_name || "NA"} / LP#: {carData?.car_no}) VIN#:{" "}
                            {carData?.vin || "NA"} / Make Year: {carData?.make_year || "NA"} /
                            Model: {carData?.model_name || "NA"}
                        </div>
                    </div>{" "}
                    <div className="rowCLssForm">
                        <div className="form-label">Driver Name :-</div>
                        <div className="form-value">
                            {data?.first_name || "NA "} {data?.last_name || "NA "}
                        </div>
                    </div>{" "}

                    <div className="rowCLssForm">
                        <div className="form-label"> Picture of Dashboard (ODO & GAS) :-</div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                className="DriingLImg"
                                src={carimage + data?.drop_gas_and_odo_image || "/placeholder.svg"}
                                style={{ maxWidth: "300px", maxHeight: "200px" }}
                            />
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Pictures of the Car (Font Left) :-</div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                className="DriingLImg"
                                src={carimage + data?.frontLeft || "/placeholder.svg"}
                                style={{ maxWidth: "300px", maxHeight: "200px" }}
                            />
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Pictures of the Car (Font Right)</div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                className="DriingLImg"
                                src={carimage + data?.frontRight || "/placeholder.svg"}
                                style={{ maxWidth: "300px", maxHeight: "200px" }}
                            />
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Pictures of the Car (Back Left)</div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                className="DriingLImg"
                                src={carimage + data?.backLeft || "/placeholder.svg"}
                                style={{ maxWidth: "300px", maxHeight: "200px" }}
                            />
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Pictures of the Car (Back Right)</div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                className="DriingLImg"
                                src={carimage + data?.backRight || "/placeholder.svg"}
                                style={{ maxWidth: "300px", maxHeight: "200px" }}
                            />
                        </div>
                    </div>
                </div>
                {/*----------------------Slide 2---------------------------- */}
                <div className="AgreePart2" id="AgreePart2">
                    <div className="rowCLssForm">
                        <div className="form-label">IPASS Picture :-</div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                src={carimage + data?.ipass_picture || "/placeholder.svg"}
                                alt="Dashboard"
                                className="DriingLImg"
                            />
                        </div>
                    </div>{" "}
                    <div className="rowCLssForm">
                        <div className="form-label">
                            IPSS # (Last 5 Digit of IPASS #) :-{" "}
                        </div>
                        <div className="form-value">{data?.ipass_number || " "}</div>
                    </div>{" "}
                    <div className="rowCLssForm">
                        <div className="form-label">
                            Picture of Key(Showing All Buttons) :-{" "}
                        </div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                src={carimage + data?.key_image || "/placeholder.svg"}
                                alt="Dashboard"
                                className="DriingLImg"
                            />
                        </div>
                    </div>{" "}

                    <div className="rowCLssForm">
                        <div className="form-label">
                            Matched Last 8 Digits of VIN with Insurance ID :-
                        </div>
                        <div className="form-value">{data?.vin || "NA "}</div>
                    </div>{" "}

                    <div className="rowCLssForm">
                        <div className="form-label">
                            Picture of inside, if the car is
                            dirty. (Optional)
                        </div>
                        <div
                            className="form-value img_bg_Div"
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <img
                                src={carimage + data?.dirty_car_img || "/placeholder.svg"}
                                alt="Dashboard"
                                className="DriingLImg"
                            />
                        </div>
                    </div>{" "}
                    <div className="rowCLssForm">
                        <div className="form-label">Key Status( Optional)</div>
                        <div className="form-value">
                            {data?.key_status || "NA "}
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Claims</div>
                        <div className="form-value">
                            {data?.any_claims || "NA "}
                        </div>
                    </div>
                    <div className="rowCLssForm">
                        <div className="form-label">Please Add Notes</div>
                        <div className="form-value">
                            {data?.notes || "NA "}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
});

export default DropFormPDF;
